import React, { Component } from 'react'

import Showdown from 'showdown'

import Parallax from '../parallax/Parallax.js'

import InView from '../../containers/SectionWrapper.jsx'
import Media from './Media'
import Button from './Button'

class Section extends Component {


    render() {

        const converter = new Showdown.Converter()
        const { fields } = this.props
        const { title, text, url, media } = fields

        return (

            <div className="ptlg pblg xs-ptsm xs-pbsm">

                <div className="grid">

                    <div className="unit whole">

                        <Parallax start={0} finish={100} isReversed={true} content={

                            <InView>

                                <div className="grid">

                                    <div className="unit one-third">

                                        <h2>{title}</h2>

                                        <div dangerouslySetInnerHTML={{ __html: converter.makeHtml(text) }} />

                                        {url &&
                                            <p>
                                                <Button to={url} className="btn">More</Button>
                                            </p>
                                        }

                                    </div>

                                </div>

                            </InView>

                        } target={
                            <Media
                                data={media} 
                            />
                        } />

                    </div>

                </div>

            </div>

        );
    }
}


export default Section;